export default {
    tabbar: {
        home: '첫 페이지',
        trading: '트레이드',
        invest: '투자',
        share: '나누다',
        mine: '나의'
    },
    common: {
        deposit: '예금하다',
        withdrawal: '돈을 인출하다',
        share: '나누다',
        team: '단체',
        task: '과업',
        addr: '주소',
        logout: '취소',
        wallet: '지갑.',
        account: '계정',
        promotion: '널리 보급하다',
        details: '자세한 사정',
        dailyRevenue: '일일 수익',
        dailyRevenueList: '일일 수익 목록',
        aboutUs: '우리',
        globalPartners: '글로벌 파트너',
        totalBalance: '총잔액',
        profitList: '재테크 수익 리스트',
        notification: '통지하다',
        previous: '전조',
        close: '닫기',
        next: '다음',
        investWallet: '투자 지갑',
        financialWallet: '재테크 지갑',
        recharge: '충전하다',
        copySucceeded: '복제 성공',
        copyFailed: '복사 실패',
        promotionWallet: '지갑을 보급하다',
        registerRewardWallet: '등록 보상 지갑',
        toAddress: '받는 TRON 지갑 주소 (T 시작)',
        verifyYourPassword: '비밀번호 확인',
        serviceFee: 'Gas fees',
        confirm: '확인',
        submitted: '제출됨',
        date: '일자',
        amount: '금액',
        accountAvailableBalance: '계정 사용 가능한 잔액',
        securityPassword: '보안 암호',
        withdrawalPrincipal: '원금을 인출하다',
        withdrawalProfit: '이윤을 인출하다',
        profitRate: '이자율',
        notificationAndFAQ: 'FAQ 및 공지사항',
        FAQ: 'FAQ',
        FAQs: [
            {
                id: 'q1',
                title: 'Q:프로젝트 특징/소개',
                content: `R:
1. 업계 최초이자 검증된 감사 투자 코드인 당사의 솔루션은 스마트 계약이 투자의 미래임을 증명하는 것을 목표로 합니다. 그것의 수명과 안정성은 궁극적으로 암호화폐 산업과 사람들이 투자 및 거래에 대해 생각하는 방식을 혼란에 빠뜨릴 것입니다. 기존 토큰 산업은 토큰 사기, 사기, 시장 변동성, 사용자 자금을 훔치는 부정직한 개발자, 유동성 부족 등 많은 문제에 직면해 있습니다.

2. 우리가 보유한 신뢰성 코드는 솔루션의 구조를 기반으로 하며 우리의 솔루션은 암호화폐 산업에서 발생하는 이러한 문제와 기타 많은 문제에 의해 어떤 식으로든 영향을 받지 않습니다. 우리 플랫폼은 시장 유동성을 요구하지 않습니다. 따라서 업계 변화에 좌우되지 않기 때문에 귀하의 투자와 기대수익이 안전합니다. 대신, 우리는 새로운 사용자의 매력을 기반으로 스마트 계약을 기반으로 실행되는 솔루션을 구축했습니다! 우리의 코드와 구조는 안전하며 수명과 투명성이 보장됩니다. 따라서 우리는 각 프로모터/사용자에 대한 상세하고 투명한 통계를 갖춘 매우 매력적이고 강력한 추천 프로그램을 보유하고 있습니다. 창시자의 수익은 물론 다른 사용자의 수익도 즉시 프로필에 추가되며, 다른 DeFi 투자 솔루션과 달리 사람들은 언제든지 즉시 자금을 인출할 수 있습니다.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q2',
                title: 'Q:우리의 장점은 무엇입니까?',
                content: `R:우리 시스템은 Haze 보안 팀의 감사를 받으며 독립적인 스마트 계약 감사자가 있습니다.
1. 안전하고 신뢰할 수 있습니다. 통화를 이체할 필요가 없으며 USDT는 위험 없이 귀하의 지갑에 입금됩니다.
2. 전문 안정성: 전문 팀, 일년 내내 안정적인 운영
3. 낮은 진입 임계값: 공유 노드 채굴 수익
4.USD ETHW AI 전략-C 마이닝 풀: 통화 이체 불필요, 안정적인 수입
5. 우리는 세계 최대의 통합 DeFi 플랫폼 DEX, IMO 및 DAO를 구축하기 위해 최선을 다하고 있습니다.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q3',
                title: 'Q:어떻게 참여하나요?',
                content: `R:
1. 지갑은 체인에 있으며 지갑 스테이션에는 Dapp 브라우저가 장착되어 있습니다.
2. TRC20을 USDT에 연결하고 지갑에 입금하세요.
3. 지갑 브라우저를 통해 공왕에 입장하세요.
4. 이 프로젝트에 참여하려면 지갑에 채굴 수수료로 30 trx 이상이 있어야 합니다.
`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q4',
                title: 'Q:채굴에 참여하는 데 얼마나 걸리나요?',
                content: `R:시간을 계산할 수 없습니다. 일반적으로 4시간 이내에 완료할 수 있습니다. 기타 불확실한 사유가 발생할 경우 시간이 연장될 수 있습니다.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q5',
                title: 'Q:왜 수익을 현금화하기 위해 채굴 수수료를 지불해야 합니까?',
                content: `R:왜냐하면 이러한 채굴 참여 과정에서 고객은 이름으로만 집계되고, 생성된 채굴 수수료는 채굴자가 지불했기 때문입니다. 생성된 수입은 실제로 계약 풀에 있으며, 채굴 수수료를 지불해야만 수입으로 교환할 수 있습니다.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q6',
                title: 'Q:이익을 인출하는 방법은 무엇입니까?',
                content: `R:USDT를 획득한 후 거래 수수료를 위해 지갑에 소량의 TRX가 있어야 합니다. 한 번만 결제하면 되며, USDT 교환은 법정 영업일 기준 1일 이내에 완료됩니다. 출금을 시작하면 USDT 출금은 가입한 노드의 지갑 주소로 자동으로 전송됩니다. 다른 주소는 지원되지 않습니다.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q7',
                title: 'Q:Defi 유동성 채굴이란 무엇입니까?',
                content: `R:유동성 채굴은 DeFi 분산 금융의 한 유형입니다. 그래픽 카드를 구입하거나 컴퓨팅 파워를 기여하거나 값비싼 전기 요금을 지불할 필요가 없지만 자금과 유동성을 제공하여 수입을 얻습니다. 특히 최근에는 환율이 크게 변동했습니다. 일부 헌신적인 코인 보유자에게 유동성 채굴은 거래 없이도 수입을 얻고 더 많은 암호화폐를 축적할 수 있는 방법입니다.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q8',
                title: 'Q:어떻게 작동하나요?',
                content: `R:우리의 솔루션은 두 당사자 간의 계약 조건을 자동으로 시행하는 컴퓨터화된 거래 계약입니다. 범용 계약과 마찬가지로 플랫폼의 두 사용자 모두 거래 시 참여 규칙과 조건을 정의해야 합니다. 합의가 이루어지고 스마트 계약이 시작되면 미리 결정된 조건이 변경될 가능성이 전혀 없이 설계된 대로 작동합니다. 사용자가 블록체인 노드의 채굴 풀에서 활동을 시작하면 계약에 사용 가능한 잔액이 있어야 합니다. 나머지 사용자는 계약 실행을 위해 이를 맡기므로 더 이상 판매 또는 구매 시기를 확인하기 위해 오랜 시간을 기다릴 필요가 없습니다. 따라서 계약 조건에 따라 귀하의 투자 가치는 결코 감소하지 않을 것으로 보장됩니다. 오히려 사용자에게 100% 이익을 가져다줍니다.`,
                updatedAt: '2019-07-23 12:00:00'
            }
        ],
        minWithdrawalError: '인출금액은 소비된 가스비보다 커야 합니다.',
        supportTips: '친애하는 사용자 여러분: 우리는 귀하를 위해 독점적인 채굴 풀 보조 서비스를 설정했습니다. 상담, 불만, 제안 등을 글로 남겨주시면 24시간 이내에 답변 및 처리해드리겠습니다!',
        tips: '팁',
        Withdrawals_prohibited: '현재 철회 조건이 충족되지 않았습니다. 먼저 작업을 완료하십시오.'
    },
    homePage: {
        theCommonProblem: 'FAQ',
        latestAnnouncement: '최신 공지',
        block5title: '트론 백만장자로 합류',
        block5desc: '클라우드 캐기와 Defi 기술을 사용하여 모든 사용자가 가장 높은 USDT 수입을 얻을 수 있도록 확보한다.',
        block6title: '플랫폼 데이터 프레젠테이션',
        accumulatedProfit: '누적 이익',
        membership: '회원',
        block7title: '우리는 지금 최상의 상태에 처해 있다',
        block7desc: 'hako는 싱가포르에 등록된 회사입니다. 라이센스 번호는 PS20200556입니다. 우리는 TRON 스마트 체인(TRON) 네트워크에서 운영되는 암호화폐 공간에서 유일하게 감사되고 검증된 스마트 계약 투자 웹사이트입니다. hako 클라우드 마이닝은 비트코인 USDT 및 기타 암호화폐에 대한 잠재적으로 비용 효율적인 마이닝 파이프라인을 제공합니다. 동시에 퀀트 트레이딩과 DeFi 기술을 통해 적은 자본으로도 쉽게 블록체인 거래에 참여하고 보험 등 안정적인 수익을 얻을 수 있습니다.',
        tzl: '를 투자했습니다',
        zl: '벌었어요'
    },
    investPage: {
        productList: '제품 목록',
        investedList: '투자 목록',
        dailyRate: '일 이율',
        cycle: '사이클',
        day: '일',
        productDetails: '제품 상세 정보'
    },
    tradingPage: {
        miningWorking: '운굴광이 한창 작업 중이다',
        tradingProfit: '거래 수익',
        settlementRule: '24시간 결산',
        viewAll: '모두 보기',
        quantifyingTransactionRevenue: '질적 거래 수익',
        receive: '받다',
        received: '이미 수령',
        rule: '채굴 규칙',
        rules: '"클라우드 마이닝"을 시작하고 일일 수익을 창출하려면 "금융 지갑"에서 활성화하십시오. 지갑에 있는 USDT 잔액이 특정 조건을 충족하면 일일 수입을 받게 되며, 생성된 수입은 30일 동안 유지됩니다. 시간 내에 신청하려면 클릭하세요. 아래 표를 바탕으로 일일 수익 비율을 계산하세요.',
        profit: '이익',
        miningNotWorking: '클라우드 마이닝이 작동하지 않습니다. 활성화해 주세요.',
        balance: '균형'
    },
    sharePage: {
        text1: '연락처 초대',
        text2: '또는 친구 및 보상 획득',
        text3: '추천 및 보상 획득',
        text4: '당신의 추천 연결을 공유하여 돈을 벌기 시작합니다',
        copyLink: '복제 연결'
    },
    minePage: {
        trxDepositInvestment: 'USDT투자예금',
        trxDepositFinancial: 'USDT 재테크 예금',
        tips: '임의의 수량의 USDT를 입금하여 계좌를 활성화하고 인출 기능을 개통하다',
        appServices: '응용 서비스'
    },
    depositPage: {
        text1: '투자는 두 가지 모델로 나뉜다',
        text2: '1: 투자 지갑에 충전하면 서로 다른 주기에 따라 수익을 얻을 수 있고 만기가 되면 원금과 수익을 반환할 수 있다',
        text3: '2: 금융 지갑에서 "클라우드 마이닝" 기능을 활성화하고 매일 싱가포르 시간대(12시 이후)에 따라 수입을 받으세요.',
        text4: '메모:',
        text5: '투자 전에 당신의 투자 수요에 따라 투자 계좌나 재태크 계좌를 선택하여 투자하십시오.반드시 계좌 충전을 기다리세요.이것은 매우 관건적인 문제다.'
    },
    rechargePage: {
        trxAddress: 'TRC20-USDT 주소',
        copyAddress: '주소 복사',
        tips1: '다른 비 USDT 자산을 충전하지 마십시오.충전 후 약 5~10분 동안 기록합니다.',
        tips2: '장시간 전달되지 않으면 이 페이지를 새로 고치십시오.최소 5 USDT 투자.',
        rechargeCompleted: '충전 완료',
        inactivated: '비활성화됨',
        activated: '활성화됨',
        tips3: '반복적으로 클릭할 필요가 없습니다. 클라우드 마이닝은 요청이 전송된 후 약 5~10분 후에 작동을 시작합니다.',
        tips4: '오랫동안 활성화되지 않은 경우 활성화 버튼을 다시 클릭하십시오.',
        ActivateCloudMining: '클라우드 마이닝 활성화'
    },
    withdrawalPage: {
        text1: '기본 계정 잔액(USDT)',
        text2: '인출금은 24시간 내에 받을 것이다',
        dailyWithdrawalLimit: '일일 인출 한도액',
        unlimit: '무제한'
    },
    teamPage: {
        intro: '귀하가 직간접적으로 초대한 사용자는 귀하를 대신하여 배당금을 받을 수 있습니다. 사용자 A를 초대한다고 가정하면, 사용자 A가 얻은 금융 수입은 일정 비율의 보상으로 지갑에 전송됩니다. 사용자 A가 사용자 B를 초대하고, B가 차례로 C를 초대하면 사용자 소득의 A({lev2rate}%), B({lev3rate}%), C({lev4rate}%) 비율 보상을 받을 수 있습니다!',
        level: '등급',
        lev2: 'lv.2',
        lev3: 'lv.3',
        lev4: 'lv.4',
        quantity: '수량',
        rewards: '장려하다.'
    },
    productDetailsPage: {
        startingAmount: '시작 금액',
        maxInvestmentAmount: '최대 투자액',
        dailyInterestRate: '일 이율',
        investableQuantity: '투자 가능 수량',
        investmentAmount: '투자액',
        participateInInvestment: '투자 참여'
    },
    investedListPage: {
        investmentTime: '투자 시간',
        settlementTime: '결산 시간',
        settlementAmount: '결제 금액'
    },
    loginPage: {
        MobileNumber: '휴대폰 번호',
        LoginPassword: '로그인 암호',
        SignIn: '로그인',
        SignUp: '등록!',
        rememberThePassword: ' 암호 기억하기',
        inviteCode: '초대 코드',
        captcha: '인증 코드',
        EncryptedRegistration: '암호화 등록',
        desc: '비밀번호는 분산된 파이프로 저장되어 있어 분실 후 검색할 수 없습니다.비밀번호를 기억해 주세요. ',
        registerSuccess: '계정이 생성되었습니다.'
    },
    taskPage: {
        desc: '당신이 등록한 하급 회원을 초청한 모든 유효 충전 금액은 일정한 비율에 따라 당신의 인출액으로 전환됩니다(보상 계좌 보급)',
        rwconvertRate: '변환 비율',
        totalLimit: '누적 한도',
        availableLimit: '가용 한도',
        contactService: '고객지원'
    },
    Please_unlock_your_wallet: '지갑을 열어주세요',
    Please_open_the_website_in_the_Dapp_browser: 'Dapp 브라우저에서 웹사이트를 열어주세요'
}
